/**
 * Upload is retired; callers must handle rejection.
 * @param {File} _file
 * @returns {Promise<{ id: string, name: string, link: string, ext: string }>}
 */
export const uploadFile = _file =>
  Promise.reject(
    new Error('Image upload is unavailable: this flow has been retired.')
  );
